import React from 'react';
import QuoteCard from './QuoteCard';
import { styled } from "../../../stitches.config";
import CustomSlider from './CustomSlider';


type QuoteCardTypes = {
    text: string,
    video: string,
}


const QuoteCards: QuoteCardTypes[] = [
    {
        text: 'Od 2018 roku pracuję w naTemat.pl. Dlaczego lubię tu pracować? Przede wszystkim za atmosferę w redakcji. Pamiętam swoją rozmowę rekrutacyjną, którą prowadził nasz szef, Michał Mańkowski i podkreślał na niej, że w naTemat dba się o atmosferę w pracy, w zespole. I tak rzeczywiście jest.',
        video: 'https://www.youtube.com/embed/y8WOQiGBLBY',
    },
    {
        text: 'Kiedy przyszłam do naTemat, pracowałam w mediach już 8 lat. Okazało się jednak, że jest to zupełnie inny świat. Internet i zasady w nim obowiązujące na początku były dla mnie czarną magią, ale na tyle pociągającą i intrygującą, że nie zamierzałam się poddawać. Praca w portalu nie jest łatwa.', //Co oczywiste trzeba się orientować w otaczającej rzeczywistości, błyskawicznie reagować na zmiany (tym bardziej, że temat ma być zazwyczaj na już!) i przewidywać, co może zainteresować czytelniczki i czytelników. Jeśli uda się choć trochę dostosować do tych warunków – i nie paść ze zmęczenia lub ze stresu – można czerpać z tego, co się robi ogromną satysfakcję. Nie chciałabym, żeby zabrzmiało to patetycznie albo tak jakbym walczyła o premię, ale ostatnie półtora roku w naTemat bardzo wiele mnie nauczyło. Tu odważyłam się sięgać po trudniejsze tematy i mierzyć się z tym, co wydawało mi się być poza moim zasięgiem. Oczywiście nic na siłę, bo historii do opowiedzenia jest tak wiele i dotyczą one tak różnych dziedzin, że każdy znajdzie swoja "specjalizację". Nie mogę też pominąć ludzi, którzy tu pracują. Moim zdaniem jest to świetny zespół. Podkreślam słowo "zespół", bo choć każdy siedzi przy swoim biurku i pracuje sam nad swoim tematem, to na tych ludzi naprawdę można liczyć, zarówno wtedy, kiedy temat się "sypie", jak i wtedy, gdy chcesz zamienić z kimś kilka zdań w trakcie przerwy obiadowej. ',
        // ChatGPT parsing: text: 'Po 8 latach pracy w mediach przyszłam do naTemat i odkryłam, że to zupełnie inny świat. Praca w portalu jest wymagająca - trzeba błyskawicznie reagować na zmiany, orientować się w rzeczywistości i przewidywać co może zainteresować czytelników. Półtora roku w naTemat nauczyło mnie wiele i pozwoliło sięgnąć po trudniejsze tematy. Pracuje tu świetny zespół, z którym można liczyć zarówno w trudnych, jak i przyjemnych chwilach.',
        video: 'https://www.youtube.com/embed/XwcNRU3LyZ0',
    },
    {
        text: 'W mojej codziennej pracy w Grupie Natemat najbardziej cenię atmosferę, jaka panuje w redakcji. Brak tu korporacyjnych zasad czy zachowań. Wyścig szczurów, rywalizacja - to nie u nas. Tu stawia się na współpracę i wspiera rozwój dziennikarzy. Kliki za wszelką cenę? Zapomnij, to nie tutaj.', //Ta redakcja daje dziennikarzom przestrzeń na realizowanie wymyślonych przez nich projektów, czasem dziwnych (jak słynny monolit), innym razem szalonych jak wynajęcie największego billboardu w centrum nowojorskiego Times Square z okazji 100-lecia odzyskania przez Polskę niepodległości. Tu liczy się człowiek i jego pomysły, a nie numerki w tabelce. To rzadkość w dzisiejszych czasach.',
        video: 'https://www.youtube.com/embed/ewhbPVm2lMg',
    }
]

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 996,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            },
        }
    ]
};

const Quotes = () => {
    return (
        <QuoteWrapper>
            <CustomSlider {...settings} className="quotes-slider">
                {
                    QuoteCards.map((item, index) => {
                        return (
                            <QuoteCard text={item.text} video={item.video} key={index} />
                        )
                    })
                }
            </CustomSlider>
        </QuoteWrapper>
    )
}

export default Quotes;

const QuoteWrapper = styled('div', {
    width: '90%',
    height: '80%',
    '.slick-slider': {
        height: '100%',
        '.slick-list': {
            height: '100%',
            '.slick-track': {
                display: 'flex',
                gap: '8px',
                height: '100%',
                '.slick-slide': {
                    height: '100%',
                    '& > div': {
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%',
                    }
                },
            },
        },
        '.slick-dots': {
            'li': {
                backgroundColor: '$grayscale100',
                borderRadius: '50%',
                width: '10px',
                height: '10px',
                opacity: 0.1,
                'button': {
                    '&:before': {
                        dispay: 'none',
                    },
                },
                '&.slick-active': {
                    backgroundColor: '$primary',
                    opacity: 1,
                    'button': {
                        '&::before': {
                            display: 'none'
                        },
                    },
                },
            },
        },
        '.slick-arrow': {
            display: 'none',
        },
    },
    '@bp4': {
        maxWidth: '1440px',
        '.quotes-slider': {
            height: '100%',
            '.slick-slider': {
                '.slick-track': {
                    display: 'flex',
                    gap: '24px',
                },
                '.slick-prev': {
                    display: 'block',
                    background: '$grayscale100Fixed',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(-90deg) translate(50%, 15px)',
                    '&::before': {
                        content: '',
                    },
                    '&:focus': {
                        background: '$grayscale100Fixed',
                    },
                    '&:hover': {
                        background: '$grayscale100Fixed',
                        cursor: 'pointer',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        'path': {
                            fill: '#FFFFFF'
                        }
                    }
                },
                '.slick-next': {
                    display: 'block',
                    background: '$grayscale100Fixed',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    zIndex: 100,
                    transform: 'rotate(90deg) translate(-50%, 15px)',
                    '&::before': {
                        content: '',
                    },
                    '&:hover': {
                        background: '$grayscale100Fixed',
                        cursor: 'pointer',
                    },
                    '&:focus': {
                        background: '$grayscale100Fixed',
                    },
                    'svg': {
                        transform: 'translate(50%,50%)',
                        'path': {
                            fill: '#FFFFFF'
                        }
                    }
                },
                '.slick-dots': {
                    transform: 'translateY(-50px)',
                    'li': {
                        background: '$grayscale100',
                        borderRadius: '50%',
                        width: '10px',
                        height: '10px',
                        'button': {
                            '&:before': {
                                dispay: 'none',
                            },
                        },
                        '&.slick-active': {
                            background: '$primary',
                            opacity: 1,
                            'button': {
                                '&::before': {
                                    display: 'none',
                                },
                            },
                        },
                    },
                },
            },
        }
    }
})